/* 🤖 this file was generated by svg-to-ts */
export const mgcIconCursor2Filled: {
  name: 'cursor-2-filled';
  data: string;
} = {
  name: 'cursor-2-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5.098 4.155c-.196.051-.536.251-.644.379a1.22 1.22 0 0 0-.312.826l-.002.3 2.695 6.733c2.636 6.584 2.7 6.737 2.88 6.921.501.511 1.279.52 1.779.02.117-.117.399-.644 1.173-2.19l1.02-2.036 2.406 2.401c2.672 2.666 2.54 2.556 3.041 2.524a.925.925 0 0 0 .899-.899c.032-.501.142-.369-2.524-3.041l-2.401-2.406 2.036-1.02c2.187-1.095 2.262-1.142 2.439-1.527.132-.289.156-.524.082-.814-.076-.294-.207-.513-.411-.68-.111-.092-1.929-.836-6.852-2.805-7.053-2.821-6.941-2.78-7.304-2.686"/></svg>`
};
